<template>
  <div :class="['progress-bar', `progress-bar--${variant}`]">
    <div class="progress-bar__track">
      <div
        :style="{ width: `${filledPercent}%` }"
        class="progress-bar__fill"
      />
    </div>

    <div class="progress-bar__points">
      <div
        v-for="(point, index) in points"
        :key="index"
        :class="[
          'progress-bar__point',
          { 'progress-bar__point--active': filledPercent >= point.activeFrom },
        ]"
      >
        <nuxt-icon
          :name="point.icon"
          filled
        />
        <nuxt-icon
          v-if="point.badge"
          :name="point.badge"
          filled
        />
        <p
          v-if="point.label"
          :class="[
            'progress-bar__label',
            { 'progress-bar__label--with-suffix': point.labelSuffix },
          ]"
        >
          {{ point.label }} <span v-if="point.labelSuffix">{{ point.labelSuffix }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ProgressPoint } from '../interfaces/progressBar.interface';
import type { ProgressBarVariant } from '../types/progressBar';

const { progress, points, variant } = defineProps<{
  progress: number
  points: ProgressPoint[]
  variant: ProgressBarVariant
}>();

const filledPercent = computed((): number => Math.min(Math.max(progress, 0), 100));
</script>

<style lang="scss" scoped>
  @use '../assets/styles/progress-bar/base';
  @use '../assets/styles/progress-bar/quiz';
  @use '../assets/styles/progress-bar/upsale';
</style>
